import { PRIORITY_MAIL_INTERNATIONAL, USPS_PRIORITY } from './shippingConstants';

/**
 * A carrier's USPS Priority service level for the given scope ('Domestic' or 'International'),
 * as a list (empty when it has none). The service levels are copies without their `_params`;
 * the carrier passed in is left as it is.
 */
export const getUSPSData = (data, type) => {
  if (!data || !type) {
    throw new Error('Invalid data or type provided');
  }

  const serviceLevelMap = {
    Domestic: USPS_PRIORITY,
    International: PRIORITY_MAIL_INTERNATIONAL,
  };

  return (data.service_levels || [])
    .filter(
      serviceLevel => serviceLevel && serviceLevel.name.toLowerCase() === serviceLevelMap[type]
    )
    .map(({ _params, ...serviceLevel }) => serviceLevel);
};
